import { useSearchParams } from 'react-router-dom'

export enum PaginationFilterParam {
  Page = 'page',
}

export function usePage() {
  const [searchParams, setSearchParams] = useSearchParams()

  const pageSearchParam = searchParams.get(PaginationFilterParam.Page)
  const page = pageSearchParam ? parseInt(pageSearchParam) : 1

  const setPage = (page: number) => setSearchParams((prev) => {
    if (page > 0) {
      prev.set(PaginationFilterParam.Page, page.toString())
    } else {
      prev.delete(PaginationFilterParam.Page)
    }
    return prev
  })

  return {
    page,
    setPage,
    nextPage: () => setPage(page + 1),
  }
}
